import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { CartLinePriceFragmentDoc } from './CartLinePrice.generated';
import { ProductVariantPriceRangeFragmentDoc } from './ProductVariantPriceRange.generated';
import { RewardProgramFragmentDoc } from './RewardProgram.generated';
export type CartLineFragment = { id: string, pk: number, quantity: number, unitPrice: { currency: string, discount: number, undiscount: number }, variant: { id: string, pk: number, sku: string, isSupply: boolean, shippingRequired: boolean, stockQuantity: number, thumbnailUrl: string | null, isCustomizable: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, properties: Array<{ id: number, attributeName: string, valueName: string }>, product: { id: string, pk: number, siteSpecifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string, thumbnailUrl: string | null, categories: Array<{ id: string, name: string, sortOrder: number | null, level: number }> }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> }, wholesalePrice: { currency: string, discount: number, undiscount: number } } };

export const CartLineFragmentDoc = gql`
    fragment CartLine on CartLineType {
  id
  pk
  quantity
  unitPrice {
    ...CartLinePriceFragment
  }
  variant {
    id
    pk
    sku
    isSupply
    shippingRequired
    stockQuantity
    thumbnailUrl(size: "600x0", method: THUMBNAIL_WEBP)
    isCustomizable
    priceRange {
      ...ProductVariantPriceRangeFragment
    }
    properties {
      id
      attributeName
      valueName
    }
    product {
      id
      pk
      siteSpecifics: specifics(filters: {siteSpecifics: true}) {
        id
        pk
        name
        shortName
        slug
        thumbnailUrl(size: "600x0", method: THUMBNAIL_WEBP)
        categories {
          id
          name
          sortOrder
          level
        }
      }
      rewardPrograms {
        ...RewardProgramFragment
      }
    }
    wholesalePrice {
      currency
      discount
      undiscount
    }
  }
}
    ${CartLinePriceFragmentDoc}
${ProductVariantPriceRangeFragmentDoc}
${RewardProgramFragmentDoc}`;